import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const AccessIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25ZM14.5496 12.8435C15.3065 11.7527 15.75 10.4282 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 10.4282 2.69354 11.7527 3.45038 12.8435C4.29446 11.7285 6.27795 11.25 9 11.25C11.722 11.25 13.7055 11.7286 14.5496 12.8435ZM13.4735 14.0548C13.254 13.2655 11.677 12.75 9 12.75C6.32296 12.75 4.746 13.2655 4.52649 14.0548C5.71747 15.1096 7.28395 15.75 9 15.75C10.716 15.75 12.2825 15.1096 13.4735 14.0548ZM9 4.5C7.18432 4.5 6 5.81682 6 7.5C6 10.0705 7.32065 11.25 9 11.25C10.6636 11.25 12 10.1097 12 7.65C12 5.94118 10.8106 4.5 9 4.5ZM7.5 7.5C7.5 9.20194 8.11366 9.75 9 9.75C9.88328 9.75 10.5 9.22379 10.5 7.65C10.5 6.71281 9.91174 6 9 6C8.0503 6 7.5 6.61187 7.5 7.5Z"
    />
  </SvgIcon>
);

export default AccessIcon;
